module.exports = __webpack_public_path__ + "media/icook.1868fccb.mp3";